var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto my-12"},[_c('v-card-title',[_c('p',[_vm._v(_vm._s(_vm.$t("We're sorry, we're not able to retrieve this information at the moment, please try back later")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }